<template>
    <div class="biz header-nav">
        <h1>Biz</h1>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "Biz",
});
</script>
